import Plugin from "@wielink/datatables/Plugins/Plugin";

class ClickableRow extends Plugin {
	init() {
		this.$table.on('click', 'tr', this.rowClicked.bind(this));
	}

	rowClicked(event) {
		let preventOnElements = ['a', 'button', ':input', '.dt-select', 'td.dtr-control', 'th', '.dt-empty'];
		let prevent = false;

		preventOnElements.forEach((element) => {
			if($(event.target).is(element) || $(event.target).closest(element).length > 0) {
				prevent = true;
			}
		});

		if(prevent) {
			return;
		}

		if(!this.config.rowUrl) {
			return;
		}
		let row = this.datatable.api().rows(event.currentTarget).data()[0]
		let url = this.config.rowUrl;
		for(let key in row) {
			url = url.replace(`_${key}_`, row[key]);
		}
		if(window.handleRedirect) {
			window.handleRedirect(url);
		} else {
			window.location.href = url;
		}
	}
}

export default ClickableRow;